import { Injectable } from "@angular/core";
import { FiltroRespuesta } from "../../../../layout/investigaciones/ver-respuestas/Filtro.respuestas";
import { groupBy, intersection } from "lodash-es";
import { Nilable } from "@shared/utils";
import { Respuesta } from "../../../../layout/investigaciones/ver-respuestas/Respuesta";
import { TipoCacheRespuestaEnum } from "@shared/enums";
import { CacheRespuestas } from "./ProcesoRespuestas/CacheRespuestas";
import { RespuestaUsuario } from "@DTOS";

@Injectable({
    providedIn: "root"
})
export class RespuestasHelper {
    constructor(private cacheRespuestas: CacheRespuestas) {}

    public obtenerIndices(respuestas: RespuestaUsuario[], filtros: FiltroRespuesta[]): number[] {
        let indices: number[] = Array.from(Array(respuestas.length).keys());

        const agrupados = groupBy(filtros, filtro => filtro.pregunta.texto);
        Object.keys(agrupados).forEach(claveAgrupados => {
            const indicesAgrupados: number[] = [];
            const filtrosAgrupados = agrupados[claveAgrupados];

            filtrosAgrupados.forEach(filtro => {
                indicesAgrupados.push(...this.obtenerIndicesFiltro(filtro));
            });

            indices = intersection(indices, indicesAgrupados);
        });

        return indices;
    }

    private obtenerIndicesFiltro(filtro: FiltroRespuesta): number[] {
        const indices = this.obtenerIndicesEjeBasico(filtro);

        if (indices.length !== 0) {
            return indices;
        }

        return this.obtenerIndicesRespuestas(filtro);
    }

    private obtenerIndicesEjeBasico(filtro: FiltroRespuesta): number[] {
        let indices: number[] = [];
        let respuestas: Nilable<Respuesta[]> = null;

        switch (filtro.pregunta.texto) {
        case "genero":
            respuestas = this.cacheRespuestas.obtenerRespuestas(TipoCacheRespuestaEnum.GENEROS);
            break;
        case "edad":
            respuestas = this.cacheRespuestas.obtenerRespuestas(TipoCacheRespuestaEnum.RANGOS_EDAD);
            break;
        case "pais":
            respuestas = this.cacheRespuestas.obtenerRespuestas(TipoCacheRespuestaEnum.PAISES);
            break;
        case "region":
            respuestas = this.cacheRespuestas.obtenerRespuestas(TipoCacheRespuestaEnum.REGIONES);
            break;
        case "ciudad":
            respuestas = this.cacheRespuestas.obtenerRespuestas(TipoCacheRespuestaEnum.CIUDADES);
            break;
        }

        if (respuestas == null) {
            return [];
        }

        respuestas.forEach(respuesta => {
            const expresionItem = new RegExp(filtro.item.texto, "i");

            if (expresionItem.test(respuesta.name)) {
                indices = respuesta.extra?.indices ?? [];
            }
        });

        return indices;
    }

    private obtenerIndicesRespuestas(filtro: FiltroRespuesta): number[] {
        const respuestasExtraItem = this.cacheRespuestas.obtenerRespuestaProcesada(filtro.item.id);

        if (!respuestasExtraItem) {
            return [];
        }

        return respuestasExtraItem.indices;
    }
}
